<div class="cancelamento-inscricao-container">
    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        <div class="secoes">
            @for (secao of secoes; track secao.titulo) {
                <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        @for (campo of secao.campos; track campo.label) {
                            @if (secaoEhDeDados(secao.titulo)) {
                                <div class="field">
                                    <label class="font-semibold block mb-2" [for]="idDoCampo(secao.titulo, campo.label)">{{ campo.label }}</label>
                                    <input pInputText [id]="idDoCampo(secao.titulo, campo.label)" class="w-full" [value]="valorCampo(campo)" disabled />
                                </div>
                            } @else {
                                <article
                                    class="campo"
                                    [class.campo--destaque-identificacao]="campo.label.toLowerCase().trim().startsWith('cpf') || campo.label.toLowerCase().trim().startsWith('crm') || campo.label.toLowerCase().includes('cnpj')"
                                    [class.campo--situacao]="campo.chave === 'situacao' || campo.label.toLowerCase().includes('situacao') || campo.label.toLowerCase().includes('situação')"
                                >
                                    <span class="campo-label">{{ campo.label }}</span>
                                    @if (campo.chave === 'situacao' || campo.label.toLowerCase().includes('situacao') || campo.label.toLowerCase().includes('situação')) {
                                        <span [class]="'campo-badge situacao-' + situacaoClassePorTexto(valorCampo(campo))">
                                            {{ rotuloBadgeSituacao(campo.label, valorCampo(campo)) }}
                                        </span>
                                        @if (protocoloSelecionado()?.inPago === false) {
                                            <span class="campo-badge campo-badge-pagamento nao-pago">Não pago</span>
                                        }
                                    } @else {
                                        <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
                                    }
                                </article>
                            }
                        }
                    </div>
                </app-card-content>
            }
        </div>
    }
</div>
